import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../../../auth/Auth';
import { disableOwnTenantAccount } from '../../../auth/_requests';
import { useModal } from '../../hooks/modalContext';
import { showToast } from '../../utils/showToast';

const DeleteAccount = () => {
  const { setModal } = useModal();
  const { auth, logout } = useAuth();
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    setDeleting(true);
    try {
      await disableOwnTenantAccount(auth?.data?.token);
      setModal(null);
      showToast({ message: 'Your account has been deleted.', type: 'success' });
      logout();
    } catch (error) {
      setDeleting(false);
      showToast({
        message: error instanceof Error ? error.message : 'Failed to delete account.',
        type: 'error',
      });
    }
  };

  return (
    <motion.div
      className='relative flex w-[380px] max-w-[92vw] flex-col items-center rounded-[12px] bg-[#FFF] px-10 py-10'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <AlertTriangle className='text-[#B70D0D]' />
      <span className='mt-2 text-center text-lg font-semibold text-main'>Delete account</span>
      <span className='mb-6 mt-2 text-center text-sm leading-relaxed text-[#6B7285]'>
        Are you sure you want to delete your account? Your active subscriptions will be stopped and
        any queued or pending payments will be cancelled. This action cannot be undone.
      </span>
      <div className='flex w-full justify-between gap-5'>
        <button
          type='button'
          className='cancelBtn w-full'
          disabled={deleting}
          onClick={() => setModal(null)}
        >
          Cancel
        </button>
        <button
          type='button'
          className='w-full rounded-[10px] bg-[#DC2626] px-4 py-3 text-[14px] font-semibold text-white transition-colors hover:bg-[#B91C1C] disabled:opacity-60'
          disabled={deleting}
          onClick={() => void handleConfirm()}
        >
          {deleting ? 'Deleting...' : 'Delete account'}
        </button>
      </div>
    </motion.div>
  );
};

export { DeleteAccount };
